//** Import Modules */
import socketio from "socket.io-client";
import { createContext } from "react";

//** Import Constants */
import { BE_URL } from "../common/constants";

export const socket = socketio(BE_URL);
export const SocketContext = createContext();
